import { Component, OnInit } from '@angular/core';


import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { Aspar_archive } from './Aspar_archive';
import {Globals} from '../globals';
@Component({
  selector: 'app-aspar-archive',
  templateUrl: './aspar-archive.component.html',
  styleUrls: ['./aspar-archive.component.scss']
})
export class AsparArchiveComponent implements OnInit {
  asparArchive:Aspar_archive;
  page:any;
  date:any;
  headerPic;
  selectedDateOn ;
  today: any;
  selectedDateOff ;
  url ;
  curent;
 p: any = 1;
 somethingChanged: any;
 dataToSend:any;
 dateChanged(val: any) {
  var num; ;
  this.somethingChanged = val.value.toString().split(" ");
   if(this.somethingChanged[1] == "Jan") {
    num = '01';
  } else if(this.somethingChanged[1] == "Feb") {
    num = '02';
  }
  else if(this.somethingChanged[1] == "Mar") {
    num = '03';
  }
  else if(this.somethingChanged[1] == "Apr") {
num = '04';
  }
  else if(this.somethingChanged[1] == "May") {
num = '05';
  }
  else if(this.somethingChanged[1] == "Jun") {
num = '06';
  }
  else if(this.somethingChanged[1] == "Jul") {
num = '07';
  }
  else if(this.somethingChanged[1] == "Aug") {
num = '08';
  }
  else if(this.somethingChanged[1] == "Sep") {
num = '09';
  }
  else if(this.somethingChanged[1] == "Oct") {
num = '10';
  }
  else if(this.somethingChanged[1] == "Nov") {
num = '11';
  }
  else if(this.somethingChanged[1] == "Dec") {
num = '12';
  }
this.dataToSend = this.somethingChanged[3] + "-"+num + "-"+ this.somethingChanged[2]
  // console.log(this.dataToSend)
  this.http.get<Aspar_archive>(this.globals.urlMain +'archive/aspar/'+this.curent, {
    params:{
      item: this.dataToSend
    }

  }).subscribe(data => {
    this.asparArchive = data;
    this.collection=[];
    var k =Number(data.meta.total);
    for(let i =0 ; i<= k; i++) {
      this.collection.push(i)
    }

  });
  $(window).scrollTop(0);
}
     collection: any[]=[];
  constructor(private http: HttpClient , private route: ActivatedRoute, public sanitizer: DomSanitizer , public globals: Globals) {
    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
   }

  ngOnInit() {

    $(window).scrollTop(0);
    this.stopAllAudio( );
    this.today = new Date().toISOString().split('T')[0];

    this.changeReq();
    // this.changeIframes();
    localStorage.setItem('headerImage', this.headerPic ) ;
  }
  changel(){
    this.changeReq();

  }
  changeDateOn(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    this.selectedDateOn = target.value;
    this.changeReq();
    // alert(this.today)
  }
  changeDateOff(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    this.selectedDateOff = target.value;
    this.changeReq();
    // alert(this.today)
  }
    newsDetalesFalse;
changeReq(){

  $(window).scrollTop(0);

  if(this.selectedDateOn && this.selectedDateOff) {
    this.http.get<Aspar_archive>(this.globals.urlMain +'archive/aspar/'+this.curent, {
      params:{
         page: this.p,
        dateon: this.selectedDateOn,
         dateof: this.selectedDateOff,
      }

    }).subscribe(data => {
      this.asparArchive = data;
      var k =Number(data.meta.total);
     this.collection=[];
      for(let i =0 ; i<= k; i++) {
        this.collection.push(i)
      }
      // this.headerPic = data.header_img;

    });
   } else {
    this.http.get<Aspar_archive>(this.globals.urlMain +'archive/aspar/'+this.curent, {
      params:{
         page: this.p,

      }

    }).subscribe(data => {
      this.asparArchive = data;
      var k =Number(data.meta.total);
     this.collection=[];
      for(let i =0 ; i<= k; i++) {
        this.collection.push(i)
      }


    }, error=>{
        this.newsDetalesFalse=true
    });
   }





}
  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  };

stopAllAudio( ) {
  document.addEventListener('play', function(e){
    var audios = document.getElementsByTagName('audio');
    for(var i = 0, len = audios.length; i < len;i++){
        if(audios[i] != e.target){
            audios[i].pause();
        }
    }
}, true);
}
openModal(event) {
  $('.modalForVideos').addClass('shown')
  var target = event.target || event.srcElement || event.currentTarget;
  var title = $(target).closest('.itemContent').find('.title').text();
  var iframe = $(target).closest('.iframe').find('img').attr('data-id');
  var newIframe = document.createElement('iframe');
  newIframe.src = iframe;
  newIframe.height="100%";
  newIframe.width="100%";
  newIframe.allowFullscreen= true
  $('.modalTitle').html(title);
  $('.modileIframe').html(newIframe);
}
  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }
}
